
import happyKidsInsurerQuery from '~/apollo/queries/happy-kids/happyKidsInsurer';
import happyKidsInsurerDetail from '@/apollo/queries/happy-kids/happyKidsInsurerDetail'
import happyKidsTutorialSubCategoryQuery from '~/apollo/queries/happy-kids/happyKidsTutorialSubCategory2024';
import ComparisonMobileContentSection from '~/components/products/comparison/Content/ComparisonMobileContentSection.vue';
import pageMeta from '~/mixins/pageMeta.js';
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import eventTrackingFamilySiteFnMixins from '~/mixins/eventTrackingFamilySiteFnMixins.js';
import eventTrackingFamilySiteProductCardsMixins from '~/mixins/eventTrackingFamilySiteProductCardsMixins.js';

export default {
    mixins: [pageMeta, eventTrackingMixins, eventTrackingFamilySiteFnMixins, eventTrackingFamilySiteProductCardsMixins],
    data() {
        return {
            insurers: {
                type: Object,
                default: () => [],
            },
            params: {
                type: Object,
                default: this.$route.params,
                any: this.$route.params.any,
            },
            loading: 0,
            languages: [],
            pageData: null,
            happyKidsTutorialSubCategory: null,
            happyKidsInsurer: null,
            pagesValid: {
              happyKidsInsurer: null,
              pageData: null,
              happyKidsTutorialSubCategory: null,
            },
        };
    },
    computed: {
      // showTutorial() {
      //     if (this.happyKidsTutorialSubCategory !== null) {
      //         if ((this.happyKidsTutorialSubCategory.filter(item => item.Slug === this.$route.params.any).length > 0)) {
      //             return true;
      //         }
      //     }
      //     return false;
      // },
      pageLoading() {
        return this.pagesValid.happyKidsInsurer === null && this.pagesValid.pageData === null && this.pagesValid.happyKidsTutorialSubCategory === null;
      }
    },
    watch: {
      $route(to, from) {
          console.debug('route changed')
          const that=this;
          this.$nextTick(() => {
              that.eventTrackingListenersForFamilySite(),
              that.checkProductCardImpression()
          });
      },
      pagesValid: {
        handler(newVal, oldVal) {
          if ( this.pagesValid.happyKidsInsurer === false && this.pagesValid.pageData === false && this.pagesValid.happyKidsTutorialSubCategory === false ) {
            return this.$nuxt.error({ statusCode: 404, message: 'Page not found' });
          }
        },
        deep: true
      }
    },
    apollo: {
        $loadingKey: "loading",
        happyKidsInsurer: {
            query: happyKidsInsurerQuery,
            prefetch: true,
            variables() {
                return {
                    locale: this.$normalizeLocale(this.$i18n.locale),
                    slug: this.$route?.params?.any || ""
                };
            },
            update(data) {

                if (data && data?.familyCampaignInsurers && data?.familyCampaignInsurers?.data.length !== 0) {
                    const normalizedData = this.$normalizeStrapi(data?.familyCampaignInsurers?.data)

                    if (normalizedData.length > 1) {
                        this.languages = normalizedData.map(item => {
                            return item.Language
                        })
                    }

                    if (normalizedData.length > 1) {
                        if (this.$route?.query?.lang && this.languages.some(item => item?.LangCode.toLowerCase() === this.$route?.query?.lang.toLowerCase())) {
                            const d = normalizedData.find(item => item.Language?.LangCode.toLowerCase() === this.$route?.query?.lang.toLowerCase())
                            return d;
                        } else if (!this.$route?.query?.lang && this.languages.some(item => item?.LangCode.toLowerCase() === 'tc')) {
                            const d = normalizedData.find(item => item.Language?.LangCode.toLowerCase() === 'tc')
                            return d;
                        }
                        return normalizedData[0]
                    }

                    if (normalizedData.length === 1) {
                        const d = normalizedData[0];
                        return d;
                    }
                }

                console.debug('*** data err ***')
                return null;

            },
            result({ data }) {
                this.pagesValid.happyKidsInsurer = this.happyKidsInsurer !== null;

                if (!data?.familyCampaignInsurers?.data?.length) {
                    // this.$router?.push(
                    //     {
                    //         name: "happy-kids-year___" + this.$i18n.locale,
                    //         params: {
                    //             year: this.$route.params.year,
                    //         },
                    //     }
                    // )

                    return null;
                    // return this.$nuxt.error({ statusCode: 404, message: 'Page not found' });
                }
            },
        },
        pageData: {
            prefetch: true,
            query: happyKidsInsurerDetail,
            variables() {
                return {
                    currentlocale: this.$normalizeLocale(this.$i18n.locale),
                    // year: this.$route.params.year || '2024',
                    // insurerSlug: this.$route.params.insurer,
                    detailSlug: this.$route.params.any
                };
            },
            update(data) {

              if (data && data?.familyCampaignInsurerDetails && data?.familyCampaignInsurerDetails?.data.length !== 0) {
                return this.$normalizeStrapi(data?.familyCampaignInsurerDetails?.data[0]);
              }

              return null;
            },
            result({ data }) {
              this.pagesValid.pageData = this.pageData !== null;

              if (!data || !data?.familyCampaignInsurerDetails?.data.length) {
                  // this.$router?.push(
                  //     {
                  //         name: "happy-kids-year___" + this.$i18n.locale,
                  //         params: {
                  //             year: this.$route.params.year,
                  //         },
                  //     }
                  // )
              }
              // console.debug(JSON.stringify(data));
            },
        },
        happyKidsTutorialSubCategory: {
            query: happyKidsTutorialSubCategoryQuery,
            prefetch: true,
            variables() {
                return {
                    locale: this.$normalizeLocale(this.$i18n.locale),
                    // slug: this.$route?.params?.any || "",
                    year: "2024",
                };
            },
            update(data) {

                if (data?.familyCampaignTargets?.data.length > 0) {
                    const d = this.$normalizeStrapi(data?.familyCampaignTargets?.data);

                    if (d.filter(item => item.Slug === this.$route.params.any).length > 0) {
                      // this.pagesValid.push(true);
                      return this.$normalizeStrapi(data?.familyCampaignTargets?.data);
                    }
                }

                // this.pagesValid.push(false);
                return null;
                // return this.$normalizeStrapi(data.insuranceGuides);
                // this.pageData = this.happyKidsTutorialSubCategory?.familyCampaignTargets.find(item => item.Slug === this.$route.query?.category)
                // return this.$normalizeStrapi(data.familyCampaignTargets.data);
            },
            result({ data }) {
              this.pagesValid.happyKidsTutorialSubCategory = this.happyKidsTutorialSubCategory !== null;

              if (data?.familyCampaignTargets?.data.length < 1) {
                  return null;
                }
            }
        },
    },
}
